import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
} from "@material-ui/core";

import { useStore } from "@store/store";
import Loader from "@components/loader";
import Pagination from "@components/pagination";
import { geofenceHeading } from "@utils/constant";
import { TableStyle } from "./style";
import { getPermissions, isRolePermission } from "@utils/commonFunctions";

function TableListing(props) {
  const [state] = useStore();
  const classes = TableStyle();

  return (
    <>
      <div className={classes.TableWrapper}>
        <Loader loading={state?.geofence.loading} />
        <TableContainer component={Paper} className={classes.customTable}>
          <Table
            className="account-data-table"
            aria-label="simple table"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                {geofenceHeading.map((item, index) => {
                  return (
                    <TableCell key={index} className={item.className}>
                      {item.title}
                      {item.sort && (
                        <TableSortLabel
                          direction={
                            props.orderBy === item.sortTitle
                              ? props.order
                              : "desc"
                          }
                          active={true}
                          onClick={(e) => props.handleSorting(e, item)}
                        ></TableSortLabel>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {state?.geofence?.geofenceData?.rows?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7}>No Data Found</TableCell>
                </TableRow>
              ) : (
                state?.geofence?.geofenceData?.rows?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell className="name">{item?.places?.name}</TableCell>
                    <TableCell className="city">{item?.places?.city}</TableCell>
                    <TableCell className="group">{item?.places?.verizonGroups?.groupName}</TableCell>
                    <TableCell className="address">{item?.places?.address}</TableCell>
                    <TableCell className="latitude">{item?.places?.latitude}</TableCell>
                    <TableCell className="longitude">{item?.places?.longitude}</TableCell>
                    <TableCell className="category">{item?.places?.category}</TableCell>
                    {getPermissions() && isRolePermission(getPermissions(), "geofences") && (
                      <TableCell className="delete-link">
                        <span onClick={() => props.handleOpen(item.places, item.id)}>Delete</span>
                      </TableCell>
                    )}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {state?.geofence?.geofenceData?.count?.length !== 0 && (
          <div className="pagination-wrapper">
            <Pagination
              count={state?.geofence?.geofenceData?.count?.length}
              page={props.page}
              handleChangePage={props.handleChangePage}
              rowsPerPage={props.rowsPerPage}
              handleChangeRowsPerPage={props.handleChangeRowsPerPage}
            />
          </div>
        )}
      </div>
    </>
  );
}
export default TableListing;
